"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 29.06.2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of {@link WindowSearchIndex} for DB/JSON API.
 * @author Radek Beran
 */


var WindowSearchIndexConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowSearchIndexConverter, _DataObjectConverter_);

  function WindowSearchIndexConverter() {
    _classCallCheck(this, WindowSearchIndexConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowSearchIndexConverter).apply(this, arguments));
  }

  return WindowSearchIndexConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowSearchIndexConverter = WindowSearchIndexConverter;